import React from 'react'

import {cssTheme} from '@vio/atlas/src/themes'

export const PriceTrendStable = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke={cssTheme.colors.content.brand.primary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M18 10h-5l-3-3-2 6-3-3H2"
    />
    <path
      stroke={cssTheme.colors.content.brand.primary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="m15.691 7.608 2.286 2.383-2.286 2.301"
    />
  </svg>
)
